import { withContext } from './withContext';
export function createScoped(scope) {
    return withContext({ Scopes: [scope] });
}
//# sourceMappingURL=createScoped.js.map